import React from 'react'
import './QuoteGen.css'
import { FaTwitterSquare, FaFacebookSquare } from 'react-icons/fa'
import { IconContext } from "react-icons";


export default function Bottom(props)  {
    const link = 'https://twitter.com/intent/tweet?&text=' + encodeURIComponent('"' + props.currentQuote + '" -' + props.author);
    return(
            <div className="well-bottom">
                <div>
                     <IconContext.Provider value={{className: "icons" }}>
                         <a id="tweet-quote"target="_blank" rel="noopener noreferrer" href="http://www.facebook.com"><FaFacebookSquare style={{"color": props.colors[props.counter]}} /></a>
                        <a target="_blank" rel="noopener noreferrer" href={link}><FaTwitterSquare style={{"color": props.colors[props.counter]}} /></a>
                     </IconContext.Provider>
                </div>
                <button id="new-quote"style={{"backgroundColor": props.colors[props.counter]}} onClick={props.click}>Next Quote</button>
            </div>
        )
}